import { defineStore } from "pinia";

interface iBellaTimerPromotionPopup {
  first_time_date?: string;
}
export const promotionPopupStore = defineStore("promotionPopup", {
  state: () => ({
    bellaTimerPromotionPopup: {} as iBellaTimerPromotionPopup,
  }),
  actions: {
    async setPromotionParams(payload: object) {
      this.bellaTimerPromotionPopup = payload;
    },
  },
  persist: {
    key: "bellaTimerPromotionPopup",
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
});
